import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { isApiConfigured, postAdminSignin } from "../apiClient";

export default function AdminSigninPage({ currentUser, onSignIn }) {
  const navigate = useNavigate();
  const [submitError, setSubmitError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (currentUser?.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const email = String(form.elements.adminEmail.value || "").trim();
    const password = String(form.elements.adminPassword.value || "");
    setSubmitError("");

    if (!isApiConfigured()) {
      setSubmitError("API is not configured.");
      return;
    }

    setSubmitting(true);
    try {
      const { user, token } = await postAdminSignin({ email, password });
      if (user.role !== "admin") {
        setSubmitError("This account is not authorized for admin access.");
        return;
      }
      onSignIn(user, { token });
      navigate("/admin", { replace: true });
    } catch (err) {
      setSubmitError(err instanceof Error ? err.message : "Sign in failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="preview-gate-page">
      <div className="preview-gate-card jw-admin-signin-card">
        <h1 className="preview-gate-title">Ops sign in</h1>
        <p className="preview-gate-copy">Use your admin email and password.</p>
        <form className="preview-gate-form" onSubmit={handleSubmit}>
          <label className="preview-gate-label" htmlFor="adminEmail">
            Email
          </label>
          <input
            id="adminEmail"
            name="adminEmail"
            className="preview-gate-input"
            type="email"
            autoComplete="username"
            required
          />
          <label className="preview-gate-label" htmlFor="adminPassword">
            Password
          </label>
          <input
            id="adminPassword"
            name="adminPassword"
            className="preview-gate-input"
            type="password"
            autoComplete="current-password"
            required
          />
          {submitError ? (
            <p className="preview-gate-error" role="alert">
              {submitError}
            </p>
          ) : null}
          <button type="submit" className="preview-gate-submit" disabled={submitting}>
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
